class NumPreorder extends HTMLElement {
  static get observedAttributes() {
    return ['variants', 'initial-variant'];
  }

  constructor() {
    super();
    this.variants = [];
    this.initialVariant = null;
    this.currentVariantId = null;

    this.overrideHistoryMethods();
    this.attachEventListeners();
  }

  attachEventListeners() {
    window.addEventListener('popstate', this.updateCurrentVariant.bind(this));
    window.addEventListener('historychange', this.updateCurrentVariant.bind(this));
  }

  overrideHistoryMethods() {
    const triggerHistoryChangeEvent = () => window.dispatchEvent(new CustomEvent('historychange'));
    const methods = ['pushState', 'replaceState'];

    methods.forEach((method) => {
      const originalMethod = history[method];
      history[method] = (...args) => {
        originalMethod.apply(history, args);
        triggerHistoryChangeEvent();
      };
    });
  }

  connectedCallback() {
    this.updateVariants();
    this.updateInitialVariant();
    this.updateCurrentVariant();
  }

  updateVariants() {
    const variantsAttr = this.getAttribute('variants');
    this.variants = variantsAttr ? JSON.parse(variantsAttr) : [];
  }

  updateInitialVariant() {
    this.initialVariant = this.getAttribute('initial-variant');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'variants') {
      this.variants = JSON.parse(newValue);
    } else if (name === 'initial-variant') {
      this.initialVariant = newValue;
    }
    this.updateCurrentVariant();
  }

  updateCurrentVariant() {
    const variantId = this.getVariantIdFromURL() || this.initialVariant;

    if (variantId !== this.currentVariantId) {
      this.currentVariantId = variantId;
      this.renderVariant();
    }
  }

  renderVariant() {
    const variant = this.variants.find((v) => v.id === this.currentVariantId);

    if (!variant) {
      console.error('Variant not found.');
      return;
    }

    this.updateVariantDisplay(variant);
  }

  updateVariantDisplay(variant) {
    const elementDate = document.querySelector('.num-preorder__date');
    const elementText = document.querySelector('.num-preorder__text');

    if (!variant.preorder || variant.preorder === 'null') {
      this.hideVariantDetails(elementDate, elementText);
      return;
    }

    this.showVariantDetails(elementDate, elementText, variant.preorder);
  }

  showVariantDetails(elementDate, elementText, preorderDate) {
    elementDate.innerHTML = new Date(preorderDate).toLocaleDateString();
    elementDate.style.display = 'block';
    elementText.style.display = 'block';
  }

  hideVariantDetails(elementDate, elementText) {
    elementDate.style.display = 'none';
    elementText.style.display = 'none';
  }

  getVariantIdFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }
}

window.customElements.define('num-preorder', NumPreorder);
